import React, { useEffect, useCallback, useState} from 'react';
import RollButtons from "components/explore/mix2/RollButtons.js";
import {connect} from 'react-redux';
import '../../../Roll.scss';

const ZRollComponent = ({zobject, attributes, secondaryColor}) => { 
    return (
        <div>
          {zobject.sequencerEngine && <RollButtons
                                        color={secondaryColor}
                                        engine={zobject.sequencerEngine}
                                        sequencerEngine={zobject.sequencerEngine}/>}
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
      secondaryColor: props.zobject.attributes["secondary-color"]
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZRollComponent);
